import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Add console log to verify JavaScript is loading
console.log('🚀 main.tsx is loading...');

const rootElement = document.getElementById('root');
console.log('📍 Root element:', rootElement);

if (!rootElement) {
  console.error('❌ Root element not found!');
} else {
  console.log('✅ Root element found, creating React root...');
  try {
    createRoot(rootElement).render(<App />);
    console.log('✅ React app rendered successfully');
  } catch (error) {
    console.error('❌ Error rendering React app:', error);
  }
}
